import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_swplugin_04402a58 from 'nuxt_plugin_swplugin_04402a58' // Source: ./sw.plugin.js (mode: 'client')
import nuxt_plugin_sentryserver_25cccf7f from 'nuxt_plugin_sentryserver_25cccf7f' // Source: ./sentry.server.js (mode: 'server')
import nuxt_plugin_sentryclient_7fd94412 from 'nuxt_plugin_sentryclient_7fd94412' // Source: ./sentry.client.js (mode: 'client')
import nuxt_plugin_gtm_f4c3975e from 'nuxt_plugin_gtm_f4c3975e' // Source: ./gtm.js (mode: 'all')
import nuxt_plugin_recaptcha_75fa98ac from 'nuxt_plugin_recaptcha_75fa98ac' // Source: ./recaptcha.js (mode: 'all')
import nuxt_plugin_nuxticons_866ca926 from 'nuxt_plugin_nuxticons_866ca926' // Source: ./nuxt-icons.js (mode: 'all')
import nuxt_plugin_cookieuniversalnuxt_6dd2c463 from 'nuxt_plugin_cookieuniversalnuxt_6dd2c463' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_fontawesome_48f795bd from 'nuxt_plugin_fontawesome_48f795bd' // Source: ./fontawesome.js (mode: 'all')
import nuxt_plugin_linkcard_3a4be380 from 'nuxt_plugin_linkcard_3a4be380' // Source: ../plugins/linkcard (mode: 'all')
import nuxt_plugin_vuegtag_44730e72 from 'nuxt_plugin_vuegtag_44730e72' // Source: ../plugins/vue-gtag.js (mode: 'all')
import nuxt_plugin_dompurify_9e093c4a from 'nuxt_plugin_dompurify_9e093c4a' // Source: ../plugins/dompurify (mode: 'all')
import nuxt_plugin_i18n_6a80ea94 from 'nuxt_plugin_i18n_6a80ea94' // Source: ../plugins/i18n (mode: 'all')
import nuxt_plugin_vuemixpanel_8fbd505c from 'nuxt_plugin_vuemixpanel_8fbd505c' // Source: ../plugins/vue-mixpanel.js (mode: 'all')
import nuxt_plugin_utils_3336a20a from 'nuxt_plugin_utils_3336a20a' // Source: ../plugins/utils (mode: 'all')
import nuxt_plugin_bus_5e46274a from 'nuxt_plugin_bus_5e46274a' // Source: ../plugins/bus (mode: 'all')
import nuxt_plugin_vuesanitize_3a295974 from 'nuxt_plugin_vuesanitize_3a295974' // Source: ../plugins/vue-sanitize (mode: 'all')
import nuxt_plugin_vuehandsontable_da120170 from 'nuxt_plugin_vuehandsontable_da120170' // Source: ../plugins/vue-handsontable (mode: 'all')
import nuxt_plugin_vueshowslide_91ccbb04 from 'nuxt_plugin_vueshowslide_91ccbb04' // Source: ../plugins/vue-show-slide (mode: 'all')
import nuxt_plugin_veevalidate_6e5ad03a from 'nuxt_plugin_veevalidate_6e5ad03a' // Source: ../plugins/vee-validate (mode: 'all')
import nuxt_plugin_vuebrowsergeolocation_646f1793 from 'nuxt_plugin_vuebrowsergeolocation_646f1793' // Source: ../plugins/vue-browser-geolocation.js (mode: 'all')
import nuxt_plugin_vuejsonexcel_a434eb30 from 'nuxt_plugin_vuejsonexcel_a434eb30' // Source: ../plugins/vue-json-excel.js (mode: 'all')
import nuxt_plugin_daterangepicker_7d4529a0 from 'nuxt_plugin_daterangepicker_7d4529a0' // Source: ../plugins/daterangepicker.js (mode: 'all')
import nuxt_plugin_luxon_73388302 from 'nuxt_plugin_luxon_73388302' // Source: ../plugins/luxon.js (mode: 'all')
import nuxt_plugin_vuecharts_6d0e6a45 from 'nuxt_plugin_vuecharts_6d0e6a45' // Source: ../plugins/vue-charts.js (mode: 'all')
import nuxt_plugin_vuegapi_83a2a372 from 'nuxt_plugin_vuegapi_83a2a372' // Source: ../plugins/vue-gapi.js (mode: 'all')
import nuxt_plugin_vueqrcodecomponent_7e62a75b from 'nuxt_plugin_vueqrcodecomponent_7e62a75b' // Source: ../plugins/vue-qrcode-component (mode: 'all')
import nuxt_plugin_vueclickoutside_68b86da3 from 'nuxt_plugin_vueclickoutside_68b86da3' // Source: ../plugins/vue-click-outside (mode: 'all')
import nuxt_plugin_vuecookielaw_6b17b656 from 'nuxt_plugin_vuecookielaw_6b17b656' // Source: ../plugins/vue-cookie-law (mode: 'all')
import nuxt_plugin_vuecolor_728cb9a6 from 'nuxt_plugin_vuecolor_728cb9a6' // Source: ../plugins/vue-color (mode: 'all')
import nuxt_plugin_vuejsmodal_f50827f4 from 'nuxt_plugin_vuejsmodal_f50827f4' // Source: ../plugins/vue-js-modal (mode: 'all')
import nuxt_plugin_vueswiper_0a7132d6 from 'nuxt_plugin_vueswiper_0a7132d6' // Source: ../plugins/vue-swiper (mode: 'all')
import nuxt_plugin_modals_4f7cf348 from 'nuxt_plugin_modals_4f7cf348' // Source: ../plugins/modals (mode: 'all')
import nuxt_plugin_vuevuetour_0d8ff33e from 'nuxt_plugin_vuevuetour_0d8ff33e' // Source: ../plugins/vue-vuetour (mode: 'all')
import nuxt_plugin_vuewhatsapp_41b1d722 from 'nuxt_plugin_vuewhatsapp_41b1d722' // Source: ../plugins/vue-whatsapp (mode: 'all')
import nuxt_plugin_prettycheckboxvue_064cc13d from 'nuxt_plugin_prettycheckboxvue_064cc13d' // Source: ../plugins/pretty-checkbox-vue (mode: 'all')
import nuxt_plugin_vuebuttonspinner_b79a88ca from 'nuxt_plugin_vuebuttonspinner_b79a88ca' // Source: ../plugins/vue-button-spinner (mode: 'all')
import nuxt_plugin_vuecropperjs_5cc9fb59 from 'nuxt_plugin_vuecropperjs_5cc9fb59' // Source: ../plugins/vue-cropperjs (mode: 'all')
import nuxt_plugin_vuegmaps_72c405c1 from 'nuxt_plugin_vuegmaps_72c405c1' // Source: ../plugins/vue-gmaps (mode: 'all')
import nuxt_plugin_vueinstantsearch_9a9113e8 from 'nuxt_plugin_vueinstantsearch_9a9113e8' // Source: ../plugins/vue-instantsearch (mode: 'all')
import nuxt_plugin_vuetouchevents_04448bc4 from 'nuxt_plugin_vuetouchevents_04448bc4' // Source: ../plugins/vue-touch-events (mode: 'all')
import nuxt_plugin_vuemultiselect_f0c5f110 from 'nuxt_plugin_vuemultiselect_f0c5f110' // Source: ../plugins/vue-multiselect (mode: 'all')
import nuxt_plugin_vuenotification_25d70570 from 'nuxt_plugin_vuenotification_25d70570' // Source: ../plugins/vue-notification (mode: 'all')
import nuxt_plugin_vuephonenumberinput_745d65d5 from 'nuxt_plugin_vuephonenumberinput_745d65d5' // Source: ../plugins/vue-phone-number-input.js (mode: 'client')
import nuxt_plugin_vueslider_0ba79204 from 'nuxt_plugin_vueslider_0ba79204' // Source: ../plugins/vue-slider (mode: 'all')
import nuxt_plugin_vuesocialsharing_dccf00ce from 'nuxt_plugin_vuesocialsharing_dccf00ce' // Source: ../plugins/vue-social-sharing (mode: 'all')
import nuxt_plugin_vuetagsinput_a62107d8 from 'nuxt_plugin_vuetagsinput_a62107d8' // Source: ../plugins/vue-tagsinput (mode: 'all')
import nuxt_plugin_vuetooltip_f49054f4 from 'nuxt_plugin_vuetooltip_f49054f4' // Source: ../plugins/vue-tooltip (mode: 'all')
import nuxt_plugin_vuejsdialog_675cadfc from 'nuxt_plugin_vuejsdialog_675cadfc' // Source: ../plugins/vuejs-dialog (mode: 'all')
import nuxt_plugin_vuesax_2c3217c6 from 'nuxt_plugin_vuesax_2c3217c6' // Source: ../plugins/vuesax.js (mode: 'all')
import nuxt_plugin_Iconify_0855cb4a from 'nuxt_plugin_Iconify_0855cb4a' // Source: ../plugins/Iconify.js (mode: 'all')
import nuxt_plugin_hotjar_6900f5d3 from 'nuxt_plugin_hotjar_6900f5d3' // Source: ../plugins/hotjar.js (mode: 'all')
import nuxt_plugin_routetracker_31bded8e from 'nuxt_plugin_routetracker_31bded8e' // Source: ../plugins/route-tracker.js (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"css":false,"name":"page","mode":"out-in","appear":true,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"Linkcard","meta":[{"charset":"utf-8"},{"name":"facebook-domain-verification","content":"1fg1zbomxgkt4u3959myxehobxs7hf"},{"name":"google","content":"notranslate"},{"name":"author","content":"linkcard"},{"name":"viewport","content":"width=device-width, initial-scale=1, user-scalable=no"},{"hid":"description","name":"description","content":"Linkcard.app is the most agile, effortless and attractive way to present information about you, your brand and what you can offer in an easy-to-share format."},{"hid":"og:description","property":"og:description","content":"Linkcard.app is the most agile, effortless and attractive way to present information about you, your brand and what you can offer in an easy-to-share format."},{"hid":"og:title","property":"og:title","content":"Linkcard | Much more than a link!"},{"hid":"keywords","name":"keywords","content":"One-page website, landing page builder, mobile page, micro site"},{"hid":"og:url","property":"og:url","content":"https:\u002F\u002Fmy.linkcard.app"},{"hid":"og:type","property":"og:type","content":"website"},{"hid":"og:image","property":"og:image","content":"https:\u002F\u002Fmy.linkcard.app\u002Fogimagen.jpg"},{"hid":"mobile-web-app-capable","name":"mobile-web-app-capable","content":"yes"},{"hid":"apple-mobile-web-app-title","name":"apple-mobile-web-app-title","content":"Linkcard"},{"hid":"og:site_name","name":"og:site_name","property":"og:site_name","content":"Linkcard"}],"script":[{"src":"https:\u002F\u002Fr.wdfl.co\u002Frw.js","data-rewardful":"83e168"},{"src":"https:\u002F\u002Fjs.stripe.com\u002Fv3\u002F"},{"src":"https:\u002F\u002Faccounts.google.com\u002Fgsi\u002Fclient","async":true,"defer":true},{"src":"https:\u002F\u002Fmaps.googleapis.com\u002Fmaps\u002Fapi\u002Fjs?key=AIzaSyDhyuzW32WIEYtnmA3vdiGfTjQjZ_DyGlU&libraries=places"},{"hid":"gtm-script","innerHTML":"if(!window._gtm_init){window._gtm_init=1;(function(w,n,d,m,e,p){w[d]=(w[d]==1||n[d]=='yes'||n[d]==1||n[m]==1||(w[e]&&w[e][p]&&w[e][p]()))?1:0})(window,navigator,'doNotTrack','msDoNotTrack','external','msTrackingProtectionEnabled');(function(w,d,s,l,x,y){w[x]={};w._gtm_inject=function(i){if(w.doNotTrack||w[x][i])return;w[x][i]=1;w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.async=true;j.src='https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id='+i;f.parentNode.insertBefore(j,f);};w[y]('GTM-KNN52G24')})(window,document,'script','dataLayer','_gtm_ids','_gtm_inject')}"}],"link":[{"rel":"manifest","href":"\u002F_nuxt\u002Fmanifest.bf422738.json"},{"rel":"shortcut icon","href":"\u002F_nuxt\u002Ficons\u002Ficon_64.db1qjq5Mt8w.png"},{"rel":"apple-touch-icon","href":"\u002F_nuxt\u002Ficons\u002Ficon_512.db1qjq5Mt8w.png","sizes":"512x512"}],"style":[],"htmlAttrs":{"lang":"en"},"noscript":[{"hid":"gtm-noscript","pbody":true,"innerHTML":"\u003Ciframe src=\"https:\u002F\u002Fwww.googletagmanager.com\u002Fns.html?id=GTM-KNN52G24&\" height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\" title=\"gtm\"\u003E\u003C\u002Fiframe\u003E"}],"__dangerouslyDisableSanitizersByTagID":{"gtm-script":["innerHTML"],"gtm-noscript":["innerHTML"]}},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      errPageReady: false,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        nuxt.errPageReady = false
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (process.client && typeof nuxt_plugin_swplugin_04402a58 === 'function') {
    await nuxt_plugin_swplugin_04402a58(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_sentryserver_25cccf7f === 'function') {
    await nuxt_plugin_sentryserver_25cccf7f(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sentryclient_7fd94412 === 'function') {
    await nuxt_plugin_sentryclient_7fd94412(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_f4c3975e === 'function') {
    await nuxt_plugin_gtm_f4c3975e(app.context, inject)
  }

  if (typeof nuxt_plugin_recaptcha_75fa98ac === 'function') {
    await nuxt_plugin_recaptcha_75fa98ac(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxticons_866ca926 === 'function') {
    await nuxt_plugin_nuxticons_866ca926(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_6dd2c463 === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_6dd2c463(app.context, inject)
  }

  if (typeof nuxt_plugin_fontawesome_48f795bd === 'function') {
    await nuxt_plugin_fontawesome_48f795bd(app.context, inject)
  }

  if (typeof nuxt_plugin_linkcard_3a4be380 === 'function') {
    await nuxt_plugin_linkcard_3a4be380(app.context, inject)
  }

  if (typeof nuxt_plugin_vuegtag_44730e72 === 'function') {
    await nuxt_plugin_vuegtag_44730e72(app.context, inject)
  }

  if (typeof nuxt_plugin_dompurify_9e093c4a === 'function') {
    await nuxt_plugin_dompurify_9e093c4a(app.context, inject)
  }

  if (typeof nuxt_plugin_i18n_6a80ea94 === 'function') {
    await nuxt_plugin_i18n_6a80ea94(app.context, inject)
  }

  if (typeof nuxt_plugin_vuemixpanel_8fbd505c === 'function') {
    await nuxt_plugin_vuemixpanel_8fbd505c(app.context, inject)
  }

  if (typeof nuxt_plugin_utils_3336a20a === 'function') {
    await nuxt_plugin_utils_3336a20a(app.context, inject)
  }

  if (typeof nuxt_plugin_bus_5e46274a === 'function') {
    await nuxt_plugin_bus_5e46274a(app.context, inject)
  }

  if (typeof nuxt_plugin_vuesanitize_3a295974 === 'function') {
    await nuxt_plugin_vuesanitize_3a295974(app.context, inject)
  }

  if (typeof nuxt_plugin_vuehandsontable_da120170 === 'function') {
    await nuxt_plugin_vuehandsontable_da120170(app.context, inject)
  }

  if (typeof nuxt_plugin_vueshowslide_91ccbb04 === 'function') {
    await nuxt_plugin_vueshowslide_91ccbb04(app.context, inject)
  }

  if (typeof nuxt_plugin_veevalidate_6e5ad03a === 'function') {
    await nuxt_plugin_veevalidate_6e5ad03a(app.context, inject)
  }

  if (typeof nuxt_plugin_vuebrowsergeolocation_646f1793 === 'function') {
    await nuxt_plugin_vuebrowsergeolocation_646f1793(app.context, inject)
  }

  if (typeof nuxt_plugin_vuejsonexcel_a434eb30 === 'function') {
    await nuxt_plugin_vuejsonexcel_a434eb30(app.context, inject)
  }

  if (typeof nuxt_plugin_daterangepicker_7d4529a0 === 'function') {
    await nuxt_plugin_daterangepicker_7d4529a0(app.context, inject)
  }

  if (typeof nuxt_plugin_luxon_73388302 === 'function') {
    await nuxt_plugin_luxon_73388302(app.context, inject)
  }

  if (typeof nuxt_plugin_vuecharts_6d0e6a45 === 'function') {
    await nuxt_plugin_vuecharts_6d0e6a45(app.context, inject)
  }

  if (typeof nuxt_plugin_vuegapi_83a2a372 === 'function') {
    await nuxt_plugin_vuegapi_83a2a372(app.context, inject)
  }

  if (typeof nuxt_plugin_vueqrcodecomponent_7e62a75b === 'function') {
    await nuxt_plugin_vueqrcodecomponent_7e62a75b(app.context, inject)
  }

  if (typeof nuxt_plugin_vueclickoutside_68b86da3 === 'function') {
    await nuxt_plugin_vueclickoutside_68b86da3(app.context, inject)
  }

  if (typeof nuxt_plugin_vuecookielaw_6b17b656 === 'function') {
    await nuxt_plugin_vuecookielaw_6b17b656(app.context, inject)
  }

  if (typeof nuxt_plugin_vuecolor_728cb9a6 === 'function') {
    await nuxt_plugin_vuecolor_728cb9a6(app.context, inject)
  }

  if (typeof nuxt_plugin_vuejsmodal_f50827f4 === 'function') {
    await nuxt_plugin_vuejsmodal_f50827f4(app.context, inject)
  }

  if (typeof nuxt_plugin_vueswiper_0a7132d6 === 'function') {
    await nuxt_plugin_vueswiper_0a7132d6(app.context, inject)
  }

  if (typeof nuxt_plugin_modals_4f7cf348 === 'function') {
    await nuxt_plugin_modals_4f7cf348(app.context, inject)
  }

  if (typeof nuxt_plugin_vuevuetour_0d8ff33e === 'function') {
    await nuxt_plugin_vuevuetour_0d8ff33e(app.context, inject)
  }

  if (typeof nuxt_plugin_vuewhatsapp_41b1d722 === 'function') {
    await nuxt_plugin_vuewhatsapp_41b1d722(app.context, inject)
  }

  if (typeof nuxt_plugin_prettycheckboxvue_064cc13d === 'function') {
    await nuxt_plugin_prettycheckboxvue_064cc13d(app.context, inject)
  }

  if (typeof nuxt_plugin_vuebuttonspinner_b79a88ca === 'function') {
    await nuxt_plugin_vuebuttonspinner_b79a88ca(app.context, inject)
  }

  if (typeof nuxt_plugin_vuecropperjs_5cc9fb59 === 'function') {
    await nuxt_plugin_vuecropperjs_5cc9fb59(app.context, inject)
  }

  if (typeof nuxt_plugin_vuegmaps_72c405c1 === 'function') {
    await nuxt_plugin_vuegmaps_72c405c1(app.context, inject)
  }

  if (typeof nuxt_plugin_vueinstantsearch_9a9113e8 === 'function') {
    await nuxt_plugin_vueinstantsearch_9a9113e8(app.context, inject)
  }

  if (typeof nuxt_plugin_vuetouchevents_04448bc4 === 'function') {
    await nuxt_plugin_vuetouchevents_04448bc4(app.context, inject)
  }

  if (typeof nuxt_plugin_vuemultiselect_f0c5f110 === 'function') {
    await nuxt_plugin_vuemultiselect_f0c5f110(app.context, inject)
  }

  if (typeof nuxt_plugin_vuenotification_25d70570 === 'function') {
    await nuxt_plugin_vuenotification_25d70570(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuephonenumberinput_745d65d5 === 'function') {
    await nuxt_plugin_vuephonenumberinput_745d65d5(app.context, inject)
  }

  if (typeof nuxt_plugin_vueslider_0ba79204 === 'function') {
    await nuxt_plugin_vueslider_0ba79204(app.context, inject)
  }

  if (typeof nuxt_plugin_vuesocialsharing_dccf00ce === 'function') {
    await nuxt_plugin_vuesocialsharing_dccf00ce(app.context, inject)
  }

  if (typeof nuxt_plugin_vuetagsinput_a62107d8 === 'function') {
    await nuxt_plugin_vuetagsinput_a62107d8(app.context, inject)
  }

  if (typeof nuxt_plugin_vuetooltip_f49054f4 === 'function') {
    await nuxt_plugin_vuetooltip_f49054f4(app.context, inject)
  }

  if (typeof nuxt_plugin_vuejsdialog_675cadfc === 'function') {
    await nuxt_plugin_vuejsdialog_675cadfc(app.context, inject)
  }

  if (typeof nuxt_plugin_vuesax_2c3217c6 === 'function') {
    await nuxt_plugin_vuesax_2c3217c6(app.context, inject)
  }

  if (typeof nuxt_plugin_Iconify_0855cb4a === 'function') {
    await nuxt_plugin_Iconify_0855cb4a(app.context, inject)
  }

  if (typeof nuxt_plugin_hotjar_6900f5d3 === 'function') {
    await nuxt_plugin_hotjar_6900f5d3(app.context, inject)
  }

  if (typeof nuxt_plugin_routetracker_31bded8e === 'function') {
    await nuxt_plugin_routetracker_31bded8e(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
